export enum Paths {
    UnAuthorized = '/unauthorized',
    SA = '/targetedSSA',
    SSA = '/SA'
}
